module.exports = __webpack_public_path__ + "img/play.9af4dbad.png";